<script setup>
import { useRoute } from "vue-router";
import { computed } from "vue";
import { getBlogBySlug } from '@/utils/blogLoader'
import { marked } from "marked";

const route = useRoute();

const blog = computed(() => getBlogBySlug(route.params.slug));

const html = computed(() => {
  return blog.value?.content
    ? marked.parse(blog.value.content)
    : "<h1>Not found</h1>";
});
</script>

<template>
  <section class="container py-5">
    <div v-html="html" class="blog-content"></div>
  </section>
</template>

<style>
.blog-content {
  max-width: 800px;
  margin: auto;
  line-height: 1.8;
  margin-bottom: 100px;
}
.blog-content h1, h2, h3 {
  margin-top: 2rem;
}

.blog-content {
  font-family: "Poppins", sans-serif;
  color: var(--text-main);
}

.blog-content h1 {
  font-weight: 800;
  letter-spacing: -0.5px;
}

.blog-content p {
  color: var(--text-muted);
}

.blog-content code {
  background: var(--accent-soft);
  color: var(--accent);
  padding: 2px 6px;
  border-radius: 6px;
}
</style>